module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "popover",
    staticClass: "popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "popover-content"
  }, [_c('fieldset', {
    staticClass: "form-group mb-0"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.photoSizeId),
      expression: "photoSizeId"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "photo_size",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.photoSizeId, "1")
    },
    on: {
      "__c": function($event) {
        _vm.photoSizeId = "1"
      }
    }
  }), _c('trans-text', {
    attrs: {
      "i18nKey": "ui['7'][11]",
      "isHtml": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.photoSizeId),
      expression: "photoSizeId"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "photo_size",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.photoSizeId, "2")
    },
    on: {
      "__c": function($event) {
        _vm.photoSizeId = "2"
      }
    }
  }), _c('trans-text', {
    attrs: {
      "i18nKey": "ui['7'][12]",
      "isHtml": true
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2577c1d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover/CartPhotoSizeChangePopover.vue
// module id = 680
// module chunks = 0